// globo-price-fixer.js - versione CHIRURGICA senza gestione taglie GLOBO
(() => {
  const DEBUG = false;
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));
  const log = (...a) => { if (DEBUG) console.log('[GPF]', ...a); };

  // --- CONFIG ---
  const PRICE_SEL = '.product__price';
  const SHOPIFY_QTY_SEL = '.js-qty__num, form[action*="/cart/add"] input[name="quantity"]';
  const PRINT_CHECK_SEL = 'input[name="opzioni-stampa"]';
  const ADD_TO_CART_SELECTORS = [
    'form[action*="/cart/add"] [type="submit"]',
    'form[action*="/cart/add"] button[name="add"]',
    'button.product-form__submit',
    'button[name="add"]'
  ];

  // Categorie non stampabili
  const NON_STAMPABILI = ['zaini'];

  // Categorie accessori
  const ACCESSORI = ['scarpe', 'dpi', 'accessori'];

  // --- UTILITIES ---
  const parsePrice = (txt) => {
    if (!txt) return 0;
    let s = String(txt).replace(/\s/g,'').replace(/[()]/g,'').replace(/[^\d,.\-]/g,'');
    if (!s) return 0;
    if (s.indexOf(',')>-1 && s.indexOf('.')>-1) return parseFloat(s.replace(/\./g,'').replace(',','.'))||0;
    if (s.indexOf(',')>-1) return parseFloat(s.replace(',','.'))||0;
    return parseFloat(s)||0;
  };

  const formatMoney = (n) => {
    if (isNaN(n)) n = 0;
    try {
      return '€ ' + new Intl.NumberFormat('it-IT',{minimumFractionDigits:2,maximumFractionDigits:2}).format(n);
    } catch(e) {
      return '€ ' + (Math.round(n*100)/100).toFixed(2).replace('.',',');
    }
  };

  const getProductCategory = () => {
    const el = document.getElementById('product-category');
    if (!el) return '';
    return (el.getAttribute('data-product-type')||'').trim().toLowerCase();
  };

  const isStampabile = () => {
    const cat = getProductCategory();
    if (!cat) return true;
    return !NON_STAMPABILI.includes(cat) && !ACCESSORI.includes(cat);
  };

  const isAccessorio = () => {
    const cat = getProductCategory();
    if (!cat) return false;
    return ACCESSORI.includes(cat);
  };

  // --- MAIN ELEMENTS ---
  const priceEl = qs(PRICE_SEL);
  const shopifyQtyInput = qs(SHOPIFY_QTY_SEL);
  if (!priceEl) { console.error('GPF: elemento prezzo non trovato'); return; }
  if (!shopifyQtyInput) { console.error('GPF: selettore quantità Shopify non trovato'); return; }

  // summary box
  let summary = document.getElementById('gpf-summary-noaf');
  if (!summary) {
    summary = document.createElement('div');
    summary.id = 'gpf-summary-noaf';
    summary.style.cssText = 'margin-top:10px;padding:8px;border:1px solid #A0A0A0;border-radius:0px;background:#fff;';
    priceEl.insertAdjacentElement('afterend', summary);
  }

  // message box
  let msgBox = document.getElementById('gpf-msg-no-af');
  if (!msgBox) {
    msgBox = document.createElement('div');
    msgBox.id = 'gpf-msg-no-af';
    msgBox.style.marginTop = '8px';
    msgBox.style.display = 'none';
    summary.insertAdjacentElement('afterend', msgBox);
  }

  const showWarning = (text) => {
    msgBox.textContent=text;
    msgBox.style.display='block';
    msgBox.style.background='#FF3C00';
    msgBox.style.border='1px solid #FF3C00';
    msgBox.style.color='#FFF';
    msgBox.style.padding='8px';
    msgBox.style.borderRadius='0px';
  };
  const hideWarning = () => { msgBox.textContent=''; msgBox.style.display='none'; };

  // --- READ STATE ---
  const getUnitPrice = () => {
    if (priceEl.dataset && priceEl.dataset.gpfBasePrice) return parseFloat(priceEl.dataset.gpfBasePrice)||0;
    const val = parsePrice(priceEl.textContent||'');
    if (val>0 && priceEl.dataset) priceEl.dataset.gpfBasePrice=String(val);
    return val;
  };

  const getShopifyQty = () => {
    const v=parseInt(shopifyQtyInput.value||0,10);
    return (Number.isFinite(v)&&v>0)?v:1;
  };

  const getPrintPerPiece = () => {
    const checked = qsa(PRINT_CHECK_SEL+':checked');
    let perPiece=0;
    if(checked.length>0){
      checked.forEach(chk=>{
        const card = chk.closest('.gpo-ov-item')||chk.parentElement||chk;
        let foundValue=0;
        const candidateSelectors=['.addOn','.gpo-tooltip .addOn','.gpo-tooltip__title .addOn','label .addOn','label'];
        for(const sel of candidateSelectors){
          if(!card) break;
          const el=card.querySelector(sel);
          if(el&&el.textContent){
            const num=parsePrice(el.textContent);
            if(num>0){foundValue=num; break;}
          }
        }
        perPiece+=(foundValue||0);
      });
    }
    return perPiece;
  };

  // --- COMPUTE STATE ---
  const computeState = () => {
    const unit=getUnitPrice();
    const shopifyQty=getShopifyQty();
    const perPiece=getPrintPerPiece();
    const printTotal=perPiece*shopifyQty;
    const cartSubtotal=unit*shopifyQty;
    const previewTotal = isStampabile() ? (cartSubtotal + printTotal) : cartSubtotal;
    const printsSelected = qsa(PRINT_CHECK_SEL + ":checked").length > 0;

    return { unit, shopifyQty, perPiece, printTotal, cartSubtotal, previewTotal, printsSelected };
  };

  // --- RENDER ---
  const renderSummary = (s) => {
    const { unit, shopifyQty, perPiece, printTotal, cartSubtotal, previewTotal, printsSelected } = s;

    let html='';

    if(isAccessorio()){
      html = `
        <div style="display:flex;gap:8px;flex-wrap:wrap;flex-direction:column">
          <div><strong>PREVENTIVO</strong></div>
          <div>Prezzo unitario: <strong>${formatMoney(unit)}</strong></div>
          <div>Quantità selezionata: <strong>${shopifyQty}</strong></div>
          <div style="margin-top:8px;border-top:1px dashed #A0A0A0;padding-top:8px;">
            <div>Totale prodotti: <strong>${formatMoney(cartSubtotal)}</strong></div>
          </div>
        </div>
      `;
    } 
    else if(isStampabile()){
      html = `
        <div style="display:flex;gap:8px;flex-wrap:wrap;flex-direction:column">
          <div><strong>PREVENTIVO</strong></div>
          <div>Prezzo unitario: <strong>${formatMoney(unit)}</strong></div>
          <div>Quantità selezionata: <strong>${shopifyQty}</strong></div>
        </div>
        <div style="margin-top:8px">
          Costo della stampa (cad.): <strong>${formatMoney(perPiece)}</strong>
          ${perPiece ? `<br> Costo totale della stampa: <strong>${formatMoney(printTotal)}</strong>` : ''}
        </div>
        <div style="margin-top:8px;border-top:1px dashed #A0A0A0;padding-top:8px;">
          <div>Totale prodotti: <strong>${formatMoney(cartSubtotal)}</strong></div>
          <div style="color:#FF3C00;font-size:12px;margin-top:4px">
            <em>Nel carrello vengono mostrati i prezzi base del prodotto e i costi della stampa per ogni prodotto.</em>
          </div>
        </div>
        <div style="margin-top:8px;font-weight:bold">
          ${printsSelected ? "Totale preventivo (Stampa inclusa)" : "TOTALE PREVENTIVO (Senza stampa)"}: ${formatMoney(previewTotal)}
        </div>
        ${!printsSelected ? `
          <div style="margin-top:6px;font-size:12px;color:#FF3C00;">
            <em></em>
          </div>` : ''}
      `;
    }
    else{
      html = `
        <div style="display:flex;gap:8px;flex-wrap:wrap;flex-direction:column">
          <div><strong>PREVENTIVO</strong></div>
          <div>Prezzo unitario: <strong>${formatMoney(unit)}</strong></div>
          <div>Quantità selezionata: <strong>${shopifyQty}</strong></div>
        </div>
        <div style="margin-top:8px;border-top:1px dashed #A0A0A0;padding-top:8px;">
          <div>Totale prodotti: <strong>${formatMoney(cartSubtotal)}</strong></div>
        </div>
      `;
    }

    summary.innerHTML = html;

    if(!printsSelected && isStampabile()){
      showWarning('Non sono state selezionate opzioni di personalizzazione');
    } else {
      hideWarning();
    }
  };

  // --- RECALC ---
  let raf=0;
  const recalc = () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(()=> renderSummary(computeState()) );
  };

  const bindListeners = () => {
    shopifyQtyInput.addEventListener('input', recalc);
    shopifyQtyInput.addEventListener('change', recalc);

    qsa('.js-qty__adjust, .quantity__button').forEach(btn=>{
      btn.addEventListener('click',()=>setTimeout(recalc,50));
    });

    qsa(PRINT_CHECK_SEL).forEach(chk=> chk.addEventListener('change', recalc));
  };

  const setupObservers = () => {
    const mo = new MutationObserver(()=> setTimeout(recalc,30));
    mo.observe(document.body,{childList:true,subtree:true});
  };

  setTimeout(()=>{ bindListeners(); setupObservers(); recalc(); },80);
})();
